// Decisions of the assistant switch in the inbox header (flow 8). Pure, so they can be tested.

import { ApiError } from '../services/whatsappApi';
import type { WhatsAppAccount } from '../types/whatsapp';

export type SwitchView = 'on' | 'off' | 'disconnected';

/** Disconnected wins: with a broken connection the backend refuses to switch the assistant. */
export const switchView = (account: WhatsAppAccount | null): SwitchView => {
  if (account === null) return 'disconnected';
  if (account.status !== undefined && account.status !== 'connected') return 'disconnected';
  return account.bot_enabled ? 'on' : 'off';
};

export type ToggleStep = 'none' | 'confirm_off' | 'no_topics' | 'enable';

/**
 * What a click on the switch does. Turning off asks first; turning on without active
 * topics explains why it cannot. `active_topics` may be stale: the backend answers
 * `assistant_no_active_topics` and `toggleFailure` covers that case.
 */
export const toggleStep = (account: WhatsAppAccount | null): ToggleStep => {
  const view = switchView(account);
  if (view === 'disconnected' || account === null) return 'none';
  if (view === 'on') return 'confirm_off';
  return account.active_topics > 0 ? 'enable' : 'no_topics';
};

export const SWITCH_ERROR_TEXT = 'No se pudo cambiar el asistente. Intenta de nuevo.';

export type ToggleFailure = { kind: 'no_topics' } | { kind: 'disconnected' } | { kind: 'error'; text: string };

export const toggleFailure = (err: unknown): ToggleFailure => {
  if (err instanceof ApiError) {
    if (err.code === 'assistant_no_active_topics') return { kind: 'no_topics' };
    if (err.code === 'account_not_connected') return { kind: 'disconnected' };
  }
  return { kind: 'error', text: SWITCH_ERROR_TEXT };
};
